// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2rjuN{color:#2a343e}", ""]);
// Exports
exports.locals = {
	"loading__headingText": "_2rjuN"
};
module.exports = exports;
